export default "__VITE_ASSET__BcnvNaRM__"